__turbopack_context__.v({
  "buttonContainer": "DefaultFallback-module-scss-module__MoAmwG__buttonContainer",
  "description": "DefaultFallback-module-scss-module__MoAmwG__description",
  "errorDetails": "DefaultFallback-module-scss-module__MoAmwG__errorDetails",
  "errorDetailsSummary": "DefaultFallback-module-scss-module__MoAmwG__errorDetailsSummary",
  "errorStack": "DefaultFallback-module-scss-module__MoAmwG__errorStack",
  "retryButton": "DefaultFallback-module-scss-module__MoAmwG__retryButton",
  "root": "DefaultFallback-module-scss-module__MoAmwG__root",
  "title": "DefaultFallback-module-scss-module__MoAmwG__title",
});
